import React from "react";
import { Scale, ShieldCheck } from "lucide-react";

export default function Sharia() {
  return (
    <section id="sharia" className="py-16 md:py-24 bg-brand-bg" data-testid="sharia-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="relative rounded-[28px] overflow-hidden bg-gradient-to-br from-brand-green-light to-brand-green p-8 md:p-14 shadow-2xl ring-2 ring-brand-gold/40 fade-up">
          {/* Decorative */}
          <div className="grain-overlay" />
          <div className="absolute top-0 end-0 w-48 h-48 bg-brand-gold/10 blur-3xl rounded-full" />
          <div className="absolute bottom-0 start-0 w-56 h-56 bg-brand-gold/10 blur-3xl rounded-full" />

          <div className="relative text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-brand-gold/15 border border-brand-gold/40 backdrop-blur-sm mb-6">
              <Scale className="w-8 h-8 md:w-10 md:h-10 text-brand-gold-light" />
            </div>

            <div className="inline-block text-brand-gold-light font-bold text-sm tracking-widest uppercase mb-3">
              الضمان الشرعي
            </div>

            <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-white leading-snug">
              سلفة ميسّرة بطريقة <span className="text-gold-gradient">شرعية واضحة</span>
            </h2>

            <p className="mt-6 text-base md:text-lg text-white/90 leading-loose max-w-3xl mx-auto">
              نقدم سلفة ميسّرة بطريقة شرعية، حيث أن{" "}
              <span className="font-bold text-brand-gold-light">السلعة متوفرة</span>{" "}
              والعميل{" "}
              <span className="font-bold text-brand-gold-light">
                مخيّر بين استلامها أو بيعها نيابةً عنه
              </span>
              .
            </p>

            <div className="mt-8 flex flex-wrap justify-center gap-3">
              {[
                "معاملة شرعية موثقة",
                "شفافية كاملة في الشروط",
                "بدون أي التزامات مخفية",
              ].map((t, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold backdrop-blur-sm"
                >
                  <ShieldCheck className="w-4 h-4 text-brand-gold-light" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
